export const alertConstants = {
  SUCCESS: "ALERT_SUCCESS",
  INFO: "ALERT_INFO",
  ERROR: "ALERT_ERROR",
  VERSION_CHECK: "ALERT_VERSION_CHECK",
  CLEAR: "ALERT_CLEAR",
};
